import { CHECKLIST_SHOW_DETAILS } from './types';

export const ShowDetails = payload => ({
  type: CHECKLIST_SHOW_DETAILS,
  payload,
});
